module.exports = __webpack_public_path__ + "img/ic-contact-line.0c0aecea.png";